const LimitCalculationView = () => import("@views/limit-calculation/limit-calculation-view.vue");
import LimitCalculation from "@views/limit-calculation/limit-calculation.vue";

export const limitCalculationRoutes = [
    {
        component: LimitCalculationView,
        name: "limitCalculationHome",
        path: "limit",
        redirect: { name: "limitCalculation" },
        children: [
            {
                component: LimitCalculation,
                name: "limitCalculation",
                path: "calculation",
                meta: {
                    buttons: [
                        // { name: "CustomerContinue", action: "validatecustomer", visible: true },
                        // { name: "Print", action: "printCalculation", visible: true },
                        { name: "Send", action: "sendCalculation", visible: true },
                    ]
                }
            }
        ]
    },
];